













import debounce from 'lodash/debounce';
import { Component, Vue } from 'vue-property-decorator';
import SearchBar from './SearchBar.vue';
import SearchCategories from './searchCategories/SearchCategories.vue';
import { searchApiService } from '@/services/search-api.service';
import { SearchSuggestion } from '@/contract/suggestion.contract';
import { analyticsEventService } from '@/services/analytics/analytics-event.service';
import { AnalyticsEventName, AnalyticsEventCategory } from '@/services/analytics/analytics.contract';
import { Maybe } from '@/shared/BasicTypes';

@Component({
  components: {
    SearchBar,
    SearchCategories,
  },
})
export default class Search extends Vue {
  public suggestions = Promise.resolve([] as SearchSuggestion[]);
  public queryString = '';
  private debouncedSuggestionsSearch = debounce(() => this.suggest(), 200);

  public getSuggestions(queryString: string) {
    this.queryString = queryString;
    this.debouncedSuggestionsSearch();
  }

  public handleFreeTextSearch(selected: Maybe<SearchSuggestion>) {
    // FIXME: once it is clear how suggestions are translated to searchqueries, changes this implementation.
    if (!selected && this.queryString.length === 0) {
      return;
    }
    if (selected) {
      this.$router.push({
        name: this.Routes.Search,
        query: {
          q: selected.suggestionLabel,
        },
      });
    } else {
      analyticsEventService.trackEvent(
        AnalyticsEventName.SearchOnFreeText,
        AnalyticsEventCategory.Search,
        this.queryString,
      );
      this.$router.push({
        name: this.Routes.Search,
        query: {
          q: this.queryString,
        },
      });
    }
  }

  private suggest() {
    this.suggestions = searchApiService.getSuggestions(this.queryString);
  }
}
